export type TourLocation = { name: string; description?: string };
export type TourDetail = {
  schedule?: string[];
  locations?: TourLocation[];
  groupPrices?: string[];
  privatePrices?: string[];
  notice?: string;
  included?: string[];
  bring?: string[];
  reviewTitle?: string;
};

const standardIncluded = [
  'Обед по программе',
  'Входные билеты по программе',
  'Русскоязычное сопровождение',
  'Трансфер по программе',
  'Вода для участников',
];

const standardBring = [
  'Удобная одежда и обувь',
  'Защита от солнца',
  'Деньги в донгах на личные расходы и сувениры',
];

export const tourDetails: Record<string, TourDetail> = {
  'dnevnaya-obzornaya-ekskursiya-po-nyachangu': {
    schedule: ['9:00 — сбор участников из отелей', '14:00 — возвращение в отель'],
    locations: [
      { name: 'Пагода Лонг Шон и Белый Будда', description: 'Один из главных буддийских храмов Нячанга и знаменитая большая статуя Будды.' },
      { name: 'Католический собор Нячанга', description: 'Готический собор, построенный во французский колониальный период.' },
      { name: 'Сад камней Хон Чонг', description: 'Прибрежные скалы и панорамные виды на море.' },
      { name: 'Пагода Чук Лам Фунг', description: 'Панорамная точка на горе Чинь Кхук с видом на город и побережье.' },
      { name: 'Чамские башни По Нагар', description: 'Исторический храмовый комплекс цивилизации Чамов.' },
      { name: 'Северный пляж Нячанга', description: 'Прогулка по северной части городского побережья.' },
      { name: 'Обед в ресторане', description: 'Пауза на обед с блюдами вьетнамской кухни.' },
    ],
    groupPrices: ['Взрослые — 35$', 'Дети ростом до 120 см — 25$', 'Дети до 2 лет — бесплатно'],
    privatePrices: ['1–2 человека — 180$', '3–4 человека — 60$ с человека', '5–7 человек — 50$ с человека', '7–13 человек — 45$ с человека'],
    notice: 'Порядок посещения локаций может меняться по решению гида.',
    included: ['Обед', 'Все входные билеты', 'Русскоязычный гид', 'Трансфер на микроавтобусе', 'Вода каждому участнику'],
    bring: ['Одежда с закрытыми коленями и плечами для посещения храмов', 'Панама и солнцезащитное средство', 'Деньги в донгах на личные расходы и сувениры'],
    reviewTitle: 'Отзывы о дневной обзорной экскурсии по Нячангу',
  },
  'vechernyaya-obzornaya-ekskursiya-po-nyachangu': {
    schedule: ['14:00 — сбор участников из отелей', '20:30 — возвращение в отель'],
    locations: [
      { name: 'Пагода Да Бао', description: 'Современный буддийский храм на возвышенности с панорамным видом.' },
      { name: 'Вечерний Нячанг', description: 'Городские достопримечательности в вечернем формате.' },
      { name: 'Ресторан «Старый Нячанг»', description: 'Ужин и вечерняя программа; даты шоу необходимо уточнять у менеджера.' },
    ],
    groupPrices: ['Взрослые — 48$', 'Дети — 35$'],
    included: standardIncluded,
    bring: standardBring,
    reviewTitle: 'Отзывы о вечерней обзорной экскурсии по Нячангу',
  },
  'ekskursiya-v-dalat-so-steklyannym-mostom-iz-nyachanga': {
    schedule: ['5:00–5:30 — сбор участников из отелей', 'Около 20:00 — возвращение в Нячанг'],
    locations: [
      { name: 'Кофейные плантации', description: 'Знакомство с культурой вьетнамского кофе и остановка в крупном кофейном комплексе.' },
      { name: 'Стеклянный мост', description: 'Мост длиной около 325 метров на высоте примерно 90 метров с видами на горы и сосновый лес.' },
      { name: 'Большой Золотой Будда', description: 'Одна из ключевых локаций программы «Стеклянный мост».' },
      { name: 'Водопад Датанла', description: 'Горный водопад среди хвойных лесов; дополнительные активности оплачиваются отдельно.' },
    ],
    groupPrices: ['Взрослые — 60$', 'Дети ростом до 120 см — 42$', 'Дети ростом до 100 см — бесплатно'],
    privatePrices: ['1–2 человека — 450$', '3 человека — 490$', '4 человека — 530$', '5 человек — 570$', '6 человек — 610$'],
    notice: 'Для оформления поездки в Далат нужны ФИО и даты рождения всех участников.',
    included: ['Обед', 'Входные билеты по программе', 'Русскоязычный гид', 'Трансфер на микроавтобусе', 'Вода каждому участнику'],
    bring: ['Закрытая одежда для храмов', 'Завтрак из отеля', 'Кофта', 'Дождевик', 'Удобная обувь', 'Деньги в донгах на личные расходы'],
    reviewTitle: 'Отзывы о программе «Далат — Стеклянный мост»',
  },
  'ekskursiya-v-dalat-iz-nyachanga-premium': {
    schedule: ['5:00–5:30 — сбор участников из отелей', 'Около 20:00 — возвращение в Нячанг'],
    locations: [
      { name: 'Горный перевал', description: 'Панорамная дорога через горы и джунгли.' },
      { name: 'Кофейные плантации', description: 'Знакомство с кофе и остановка в кофейном комплексе.' },
      { name: 'Глиняная деревня', description: 'Арт-парк с необычными объектами и известной фотолокацией с каменными лицами.' },
      { name: 'Crazy House', description: 'Один из самых необычных архитектурных объектов Далата.' },
      { name: 'Пагода Линь Фуок', description: 'Буддийский храм с мозаичным декором.' },
      { name: 'Водопад Датанла', description: 'Горный водопад; катание на электросанях оплачивается отдельно.' },
      { name: 'Кофейная ферма и зоопарк', description: 'Ферма с животными и дополнительными активностями.' },
      { name: 'Канатная дорога', description: 'Панорамный маршрут над Далатом и сосновыми лесами.' },
      { name: 'Обед в ресторане', description: 'Обед по программе.' },
    ],
    groupPrices: ['Взрослые — 52$', 'Дети ростом до 120 см — 38$', 'Дети ростом до 100 см — бесплатно'],
    privatePrices: ['1–2 человека — 420$', '3 человека — 450$', '4 человека — 480$', '5 человек — 510$', '6 человек — 540$'],
    notice: 'Для оформления поездки в Далат нужны ФИО и даты рождения всех участников.',
    included: ['Обед', 'Входные билеты и канатная дорога', 'Русскоязычный гид', 'Трансфер на микроавтобусе', 'Вода каждому участнику'],
    bring: ['Закрытая одежда для храмов', 'Завтрак из отеля', 'Кофта', 'Дождевик', 'Удобная обувь', 'Деньги в донгах на личные расходы'],
    reviewTitle: 'Отзывы о программе «Далат Премиум»',
  },
  'vip-ekskursiya-v-dalat-iz-nyachanga': {
    schedule: ['5:00–5:30 — сбор участников из отелей', 'Около 20:00 — возвращение в Нячанг'],
    locations: [
      { name: 'Кофейные плантации', description: 'Знакомство с вьетнамским кофе.' },
      { name: 'Деревня хоббитов', description: 'Тематическая фотолокация с небольшими сказочными домиками.' },
    ],
    groupPrices: ['Взрослые — 45$', 'Дети — 35$'],
    notice: 'Для оформления поездки в Далат нужны ФИО и даты рождения всех участников.',
    included: standardIncluded,
    bring: standardBring,
    reviewTitle: 'Отзывы о VIP-экскурсии в Далат',
  },
  'rybalka-na-ozere-nyachang': {
    schedule: ['8:00 — сбор участников из отелей', '14:00 — возвращение в отель'],
    groupPrices: ['Взрослые — 35$', 'Дети ростом до 120 см — 25$', 'Дети до 2 лет — бесплатно'],
    included: standardIncluded,
    bring: standardBring,
    reviewTitle: 'Отзывы об озёрной рыбалке',
  },
  'morskaya-rybalka-nyachang': {
    schedule: ['8:00 — сбор участников из отелей', '14:00 — возвращение в отель'],
    locations: [{ name: 'Порт Нячанга', description: 'Посадка на индивидуальный скоростной катер и выход в море.' }],
    privatePrices: ['Индивидуальная программа — от 300$'],
    included: standardIncluded,
    bring: standardBring,
  },
  'kruiz-emperor-nyachang': {
    schedule: ['16:00 — сбор участников из отелей', '20:00 — возвращение в отель'],
    locations: [
      { name: 'Порт Нячанга', description: 'Регистрация и посадка на яхту Emperor.' },
      { name: 'Бухта Нячанга', description: 'Вечерний морской маршрут по бухте.' },
    ],
    groupPrices: ['Взрослые — 90$', 'Дети — 67$'],
    included: standardIncluded,
    bring: standardBring,
  },
  'kruiz-na-katamarane-nyachang': {
    schedule: ['14:00 — сбор участников из отелей', '20:00 — возвращение в отель'],
    locations: [{ name: 'Порт Нячанга', description: 'Регистрация, посадка на катамаран и начало морской программы.' }],
    privatePrices: ['Индивидуальная аренда катамарана — 800$'],
    included: standardIncluded,
    bring: standardBring,
  },
  'zipline-i-verevochnyj-park-v-nyachange': {
    schedule: ['8:00 — сбор участников из отелей', '14:00 — возвращение в отель'],
    locations: [{ name: 'Заповедник Хон Ба', description: 'Активная программа в природной зоне провинции Кханьхоа.' }],
    groupPrices: ['Взрослые — 58$', 'Дети — 40$'],
    included: standardIncluded,
    bring: ['Спортивная одежда', 'Закрытая удобная обувь', 'Защита от солнца'],
  },
  'kvadrocikly-v-nyachange': {
    schedule: ['8:00 — сбор участников из отелей', '14:00 — возвращение в отель'],
    locations: [{ name: 'База квадроциклов ATV', description: 'Площадка отдыха и старт маршрута на квадроциклах.' }],
    groupPrices: ['Взрослые — 64$', 'Дети — 45$'],
    included: standardIncluded,
    bring: ['Спортивная одежда', 'Закрытая удобная обувь', 'Защита от солнца'],
  },
};
